<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head"><a id="HLD1"></a>D<span class="small">EDICATION</span></p>
<p class="dtxt"><i>For my dedicated husband, Bruce, who never once thought that writing a book was a crazy idea.</i></p>
<p class="dtxt"><i>Also, to our children, Kelsey, Karly, and Tessa, who have been as excited as I am about this project.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_chapter01.vue?64f3e0f2